import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/notification.svg";
var NotificationOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  NotificationOutline_default as default
};
